export const URLS = {
  UPLOAD_DOCUMENT: "proposal/uploadDocument",
  OCR_FILE_UPLOAD:
    "proposal/uploadOcr?documentType=HEALTH_POLICY&contentType=application/pdf&lob=health",
  PORT_SAVE: "proposal/savePortabilityDetails",
  CREATE_QUOTE: "create",
  PINCODE: "pincode",
  SHARE_QUOTE: "share",
  FETCH_PROPOSAL_LIST: "proposal/fetchProposalList",
  PROFILE_DETAIL: "profileDetail",
  DECRYPT_LINK: "proposal/decryptRedirectionLink",
  COL_DATA: "proposal/colData",
  MAKE_PAYMENT: "proposal/makePayment",
  COL: "proposal/reverseFeed/col",
  DOWNLOAD_DOCUMENT: "proposal/downloadDocument",
  MEMBER_DETAILS_SAVE: "/proposal/memberDetails/save",
  LIFESTYLE_DETAILS_SAVE: "/proposal/lifestyleDetails/save",
  MEDICAL_DETAILS_SAVE: "/proposal/medicalDetails/save",
  KYC_SAVE: "proposal/kyc",
  SEND_LINK: "proposal/sendLink",
  CUSTOMER_SEARCH_DETAILS: "/quotation/customerSearchDetails",
  BANCA_DETAILS: "/proposal/bancaDetails",
  PROPOSAL_CONSENT: "proposal/consent",
  UNVERIFIED_DOCUMENTS_COPS: "proposal/unverifiedDocuments",
  NSTP_FETCH_DATA: "proposal/history",
  FETCH_DOCUMENT: "proposal/fetchDocument",
  UW_REVERSE_FEED: "/proposal/reverseFeed/uw",
  COPS_REVERSE_FEED: "proposal/reverseFeed/cops",
  QUOTE_PREMIUM_CALCULATE: "quotation/calculate-premium",
  COUNT_PROPOSALS: "proposal/countProposalStatus",
  FETCH_PROPOSAL: "proposal/fetch",
  BANCA_PARENT: "proposal/bancaValidations",
  ADDITIONAL_DOCUMENTS: "proposal/additionalDocuments",
  ADDITIONAL_INFO: "proposal/reverseFeed/additionalInfo",
  REVISE_QUOTE: "reviseQuote",
  PAYMENT_STATUS: "proposal/paymentStatus",
  PDP_BENEFITS: "productBenefits",
  BANCA_SP_DATA: "proposal/spDataValidations",
  PEP: "proposal/pep",
  DEALER_DETAILS: "dealerDetail",
  MEDICARE_NSTP_FETCH: "proposal/ipds/proposal",
  TELEMER_REVERSE_FEED: "proposal/reverseFeed/telemer",
  COMPARE_PRODUCT_BENEFITS: "compareProductBenefits",
  TRIGGER_COMMUNICATION: "trigger/communication",
  FETCH_RENEWAL: "proposal/renewals",
  POLICY_HISTORY: "proposal/policyHistory",
  ENDORSEMENT_HISTORY: "proposal/fetch/endorse/summary",
  ENDORSE_SUBMIT: "proposal/endorse",
  PACKAGED_ADDONS: "addonCovers",
  VIEW_TELEMER_DATA_BOLT: "proposal/fetchTelemerReverseFeedData",
  RENEWAL_UPDATE: "proposal/renewals",
  POLICY_ELIGIBLE: "proposal/checkPolicyEligibility",
  BRANCH_LOCATION: "proposal/producerDetails",
  TOKEN_VERIFICATION: "createToken",
  RENEWAL_HISTORY: "proposal/renewals/history",
  SEND_OTP: "proposal/sendOtp",
  VERIFY_OTP: "proposal/verifyOtp",
  CREATE_QUOTE_RENEWAL: "quotation/renewals/create",
  TELEMER_STATUS: "proposal/telemer/status",
  TELEMER_RESCHEDULE_SUBMIT: "proposal/telemer/reschedule",
  CREATE_QUOTE_PA: "pa/create",
  REVISE_QUOTE_PA: "pa/reviseQuote",
  ADDITIONAL_DEPENDENCY: "pa/additionalDependency",
  OCCUPATION_LIST: "pa/occupationList",
  ADDITIONAL_DETAILS: "/proposal/addInfoDetails/save",
  MEMBER_DETAILS_SAVE_PA: "/proposal/pa/memberDetails/save",
  MEDICAL_DETAILS_SAVE_PA: "/proposal/medicalDetails/save",
};
